module.exports = __webpack_public_path__ + "static/media/06 - Claim B.aa360baa.png";